// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { Address } from '../../../SagaBase/Address';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class KeywordAddress_abstract extends Address {
  static $t: string = 'SagaBase.Objects.KeywordAddress';
  $t: string = 'SagaBase.Objects.KeywordAddress';

  public static GetMembers(): string[] {
    return ['SearchType', 'TableId', 'Id'].concat(Address.GetMembers());
  }

  public GetMembers(): string[] {
    return KeywordAddress_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SearchType: number = 0;
  public TableId: number = 0;
  public Id: any;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
